export * from './full-calendar-ui.component';
export * from './full-calendar-ui.module';